import PropTypes from 'prop-types'
import { TableRow, TableCell } from 'components/Table'
import { MenuButton, Permitted } from 'components'
import { Button } from '@material-ui/core'
import constants from 'constants/index'

import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'
import { routes } from 'Routes'

const ChurnReasonRow = ({ churnReason, setSelectedChurnReason, setOpen }) => {
  const history = useHistory()

  const handleDestroyClick = () => {
    setSelectedChurnReason(churnReason)
    setOpen(true)
  }

  return (
    <TableRow key={churnReason?.id}>
      <TableCell disableTooltip>#{churnReason?.id}</TableCell>
      <TableCell wrap>{churnReason?.name}</TableCell>
      <TableCell>{churnReason?.description || '-'}</TableCell>
      <TableCell>{churnReason?.isSystem ? 'Sim' : 'Não'}</TableCell>
      <TableCell disableTooltip align="center">
        <Permitted
          someTags={[
            constants.permissions.CHURN_REASONS.UPDATE,
            constants.permissions.CHURN_REASONS.DESTROY,
          ]}
        >
          <MenuButton>
            <Permitted tag={constants.permissions.CHURN_REASONS.UPDATE}>
              <Button
                fullWidth
                size="small"
                disabled={churnReason?.isSystem}
                onClick={() =>
                  history.push(
                    reverse(routes.churnReasons.edit, {
                      churnReasonId: churnReason?.id,
                    }),
                  )
                }
              >
                Editar
              </Button>
            </Permitted>
            <Permitted tag={constants.permissions.CHURN_REASONS.DESTROY}>
              <Button
                fullWidth
                size="small"
                onClick={handleDestroyClick}
                disabled={churnReason?.isSystem}
              >
                Excluir
              </Button>
            </Permitted>
          </MenuButton>
        </Permitted>
      </TableCell>
    </TableRow>
  )
}

ChurnReasonRow.propTypes = {
  churnReason: PropTypes.object,
  setSelectedChurnReason: PropTypes.func,
  setOpen: PropTypes.func,
}

ChurnReasonRow.defaultProps = {
  churnReason: {},
}

export default ChurnReasonRow
